export default __webpack_public_path__ + "static/media/tip.68ee6ec7.png";